import {useSelector} from 'react-redux';

function useIsActive() {
  return useSelector((state: any) => state.profiles.isDisabled);
}

export default useIsActive;
